import React from 'react';
import { IOperatorDetailsDTO } from '../../../api/rooms.dao';
import Text from '../text/text';

interface IProps {
    operators: IOperatorDetailsDTO[];
    searchValue: string;
}

const CollapsedOperators = (props: IProps) => {
    const { operators, searchValue } = props;
    const operatorNames = operators.map(el => `${el.firstName} ${el.lastName}`).join(', ');

    return (
        <Text
            tag='div'
            message={operatorNames}
            className='attendee-list-item__header attendee-list-item__header--collapsed'
            highlightValue={searchValue}
            withEllipsis
            withHighlight
        />
    );
};

export { CollapsedOperators };